import { createContext, ReactNode, useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import Sidebar from "../components/Dashboard/Sidebar";
import ClientSsoSidebar from "../components/Dashboard/ClientSsoSidebar";
import TopNav from "../components/Dashboard/TopNav";
import { RootState } from "../app/store";
import { isClientSsoUser } from "../constants/clientSso";
import { ImageGeneratorJobsProvider } from "../pages/GenerativePlatform/ImageGeneratorJobsContext";
import { CollectionBuildSessionsProvider } from "../pages/GenerativePlatform/CollectionBuildSessionsContext";
type Props = {
  isSidebarOpen: boolean;
  setIsSidebarOpen: (isOpen: boolean) => void;
};

//Creating the context for sidenav
type SidebarContextType = {
  isSidebarOpen: boolean;
};

const defaultValue: SidebarContextType = {
  isSidebarOpen: false,
};
export const SidebarContext = createContext(defaultValue);

type SidebarProviderProps = {
  children: ReactNode;
  isSidebarOpen: boolean;
};

//provider of context
const SidebarContextProvider: React.FC<SidebarProviderProps> = ({
  children,
  isSidebarOpen,
}) => (
  <SidebarContext.Provider value={{ isSidebarOpen }}>
    {children}
  </SidebarContext.Provider>
);

const DashboardLayout = ({ isSidebarOpen, setIsSidebarOpen }: Props) => {
  const [isSidebarCollapsed, setSidebarCollapsed] = useState(false);
  const group = useSelector((state: RootState) => state.user.userInfo?.group);
  const useClientSidebar = isClientSsoUser(group);

  const handleSidebarToggle = () => {
    setSidebarCollapsed(!isSidebarCollapsed);
    setIsSidebarOpen(!isSidebarCollapsed);
  };

  useEffect(() => {
    setSidebarCollapsed(isSidebarOpen);
  }, [isSidebarOpen]);

  return (
    <ImageGeneratorJobsProvider>
      <CollectionBuildSessionsProvider>
        <div className="font-avenir flex ">
          <div
            className={`fixed top-0 left-0 h-screen bg-white shadow-md transition-all duration-500 ease-in-out ${isSidebarCollapsed ? "w-24" : "w-64"} `}
          >
            {useClientSidebar ? (
              <ClientSsoSidebar
                isCollapsed={isSidebarCollapsed}
                onToggle={handleSidebarToggle}
              />
            ) : (
              <Sidebar
                isCollapsed={isSidebarCollapsed}
                onToggle={handleSidebarToggle}
                isSidebarOpen={isSidebarOpen}
                setIsSidebarOpen={setIsSidebarOpen}
              />
            )}
          </div>
          <div
            className={`flex-grow transition-all duration-500 ease-in-out ${isSidebarCollapsed ? "ml-24" : "ml-64"} h-full`}
          >
            <div
              className={`${isSidebarCollapsed ? "w-[calc(100vw-105px)]" : "w-[calc(100vw-265px)]"} h-[78px] z-10 bg-white fixed transition-all duration-500 ease-in-out`}
            >
              <TopNav />
            </div>
            <SidebarContextProvider isSidebarOpen={isSidebarOpen}>
              <main className="bg-slate-100 mt-[80px]">
                <Outlet />
              </main>
            </SidebarContextProvider>
          </div>
        </div>
      </CollectionBuildSessionsProvider>
    </ImageGeneratorJobsProvider>
  );
};

export default DashboardLayout;
